import classNames from 'classnames'
import { DefaultIcon } from '../DefaultIcon'
import styles from './StackedImages.module.scss'

interface Props {
  src?: string
  className?: string
}

export const StackedImages = ({ src, className }: Props) => {
  return (
    <div className={classNames(styles.container, className)}>
      <div className={classNames(styles.image, styles.first)}></div>
      <div className={classNames(styles.image, styles.second)}></div>
      {src ? (
        <img src={src} className={classNames(styles.image, styles.third)} />
      ) : (
        <DefaultIcon className={classNames(styles.image, styles.third)} />
      )}
    </div>
  )
}
